export default __webpack_public_path__ + "education879894.jpg";